///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.performance = abcsetup.promos.performance || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.performance = {
    init: () =>
    {
        abcsetup.setTitle('Proof Of Performance Library');

        // Init listeners
        abcsetup.promos.performance.initListeners();

        abcsetup.promos.performance.promo_perf_library.load();
    },

    initListeners: () =>
    {
    },

    showLoading: function(panel) {
        panel.find('li.loading').remove();
        panel.find('.breadcrumb').append('<li class="loading"><img src="/img/loading.gif"></li>');
    },

    removeLoading: function(panel = null) {
        if (panel !== null) {
            panel.find('li.loading').remove();
        } else {
            $('li.loading').remove();
        }
    },

    setBadge: function(badge, value) {
        if (value > 0) {
            if (value < 10) {
                value = '&nbsp;' + value + '&nbsp;';
            }

            badge.html(value);

        } else {
            badge.empty();
        }
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Proof of Performance Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    promo_perf_library: {
        /**
         * Check if the current user's org has access to the promotions module
         */
        _check: function() {
            if (abcsetup.userOrg.promo === 'Y') {
                return true;
            }

            abcsetup.promos.performance.removeLoading($('#performance_panel'));
            $('#events_panel').find('#proof_of_performance').parent().find('.row.button-row').remove();
            $('#events_panel').find('#proof_of_performance').html('<div class="alert alert-warning mt-3"><h4 class="alert-heading">Promotions Planning Tool</h4><hr>Sorry! You currently do not have access to the Promotions Planning Tool. To find out more about this tool, please contact your Cencora Category Manager.</div>');

            return false;
        },

        /**
         * Load bugets/plans for Promo Plans
         */
        load: function() {
            $('#performance_panel').find('#performance_library table, #performance_library .dataTables_wrapper').remove();

            axios.get('/api/promo_perf_library').then(response => {
                if (response.data.table_data) {
                    $('#performance_panel').find('#performance_library').append(response.data.table_data);
                    $('#performance_panel').find('#performance_library').find('#' + response.data.table_id).addClass('table-sm');

                    // Init datatables
                    abcsetup.datatables.init($('#performance_panel').find('#performance_library').find('#' + response.data.table_id), {
                        bInfo: true,
                        "lengthMenu": [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, 'All']],
                        "iDisplayLength": 10,
                        "order": [[1,'asc' ]],
                        "responsive": true
                    });
                }

                abcsetup.promos.performance.removeLoading($('#peformance_panel'));

            }).catch(error => {
                abcsetup.promos.performance.removeLoading($('#performance_panel'));
            });
        },
    },
}
